import { useMobile } from 'src/hooks/useMobile';
// import NotificationsIcon from '@mui/icons-material/Notifications';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { SelectOutlinedCountry } from '../SelectOutlinedCountry';
// import { GradientIcon } from '../gradients/GradientIcon';
import { SOCIALS } from './headerLinks';
import { SocialIcons } from '../socials/SocialIcons';
import { ContactUsButton } from './ContactUsButton';
import { HeaderLogo } from './HeaderLogo';
import { UserLikedCount } from './UserLikedCount';
import { HeaderHamburgerIcon } from './HeaderHamburgerIcon';
import { SelectWalletAddress } from './SelectWalletAddress';
import { UserButton } from './UserButton';
import { SearchBar } from './SearchBar';
import { useAuth } from 'src/contexts/AuthContext';
const sx = {
  rowGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
  },
};

export const MIN_HEADER_HEIGHT = '60px';

export function Header() {
  // TODO: add responsiveness for small screens
  const isMobile = useMobile();
  const { userData } = useAuth();
  return (
    <>
      <AppBar position="fixed">
        <Toolbar
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-around',
            minHeight: `${MIN_HEADER_HEIGHT} !important`,
            px: { xs: 4 },
          }}
        >
          <Box sx={{ ...sx.rowGroup, flexGrow: 1 }}>
            <HeaderHamburgerIcon />
            <HeaderLogo />
            <SearchBar />
          </Box>
          {/* <HeaderPages /> */}
          <Box sx={{ ...sx.rowGroup, gap: 2, pl: { xs: 2, lg: 4 } }}>
            <SelectOutlinedCountry />

            {!isMobile && (
              <>
                <SocialIcons
                  linkedSocials={SOCIALS.slice(0, 2)}
                  disableMobile={true}
                />
                <ContactUsButton />
              </>
            )}
            <UserLikedCount />
            {/* <UserNotifications /> */}
            {!!userData && <SelectWalletAddress />}
            <UserButton />
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}
